<!-- 业务商品列表 -->
<template>
   <div class='page_content'>
      <el-drawer :close-on-press-escape="true" :wrapperClosable="false" :visible.sync="showStatus" :with-header="false"
         append-to-bodycustom-class="drawer_box" direction="ltr" size="400px">
         <hospitalBgmCodeAction v-if="showStatus" ref="hospitalBgmCodeAction" @drawerCancel="drawerCancel"
            :actionData="actionData">
         </hospitalBgmCodeAction>
      </el-drawer>
      <subComponents ref="showSelectData"></subComponents>

      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo"
            @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <vSearch @searchData="searchData" @openSearchs="openSearch" :getRequestData=getRequestData
               v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
            </vSearch>
         </div>
      </div>
      <div class="page_content_center">
         <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight"
            :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini"
            @sort-change="sortChange">
            <el-table-column label="选择操作" align="center" width="80">
               <template slot-scope="scope">
                  <el-radio v-model="selectedDataIndex" :label="scope.row.index" border size="mini">
                     <i class="el-icon-thumb"></i>
                  </el-radio>
               </template>
            </el-table-column>
            <!-- 主信息 -->
            <el-table-column v-if="tableValye.isShow == 1" align="center"
               :sortable="tableValye.isSort == 1 ? 'custom' : false"
               v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey"
               :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip
               :min-width="tableValye.fieldWeight">
               <template slot-scope="scope">
                  <span v-if="tableValye.fieldType == 'date'">
                     <span v-if="scope.row[tableValye.entityField]">
                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                     </span>
                  </span>
                  <span v-else-if="tableValye.isRift == 1">
                     <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                  </span>
                  <span v-else-if="tableValye.entityField == 'bgmActivestatus'">
                     {{ $store.state.businessGoodsState[scope.row.bgmActivestatus].name }}
                  </span>
                  <el-tag size="mini" v-else-if="tableValye.entityField == 'activestatus'">
                     {{ scope.row.activestatus == 1 ? '启用' : '停用' }}
                  </el-tag>
                  <span v-else-if="tableValye.fieldType == 'formatter'">
                     <span v-for="(item, index) in JSON.parse(tableValye.formatterContent)" :key="index">
                        <el-tag size="mini" v-if="item.key == scope.row[tableValye.entityField]">{{ item.value
                           }}</el-tag>
                     </span>
                  </span>
                  <span v-else>
                     {{ scope.row[tableValye.entityField] }}
                  </span>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
            @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
            @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- 自定义设计 -->
      <customDesign ref="customDesign"></customDesign>
      <el-dialog v-if="dialogExcel" title="导入EXCEL" :visible.sync="dialogExcel" width="60%">
         <importFile :uploadUrl="'upload/fileupload'" :importType="'hospitalcodeImport'" @closeExcel="closeExcel">
         </importFile>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import SearchScheme from "../../byComponents/SearchScheme.vue"
import hospitalBgmCodeAction from "@/components/hospitalBgmCodeAction.vue";
export default {
   //import引入的组件需要注入到对象中才能使用
   components: { SearchScheme,hospitalBgmCodeAction },
   data() {
      //这里存放数据
      return {
         requesUrl: '',
         ormId: "",
         tableHeight: 0,
         getRequestData: {
            bgmId: "",
            bgmName: "",
            page: 1,
            rows: 30,
            stName: "",
         },
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: [],
         },
         buttonList: [],
         selectedDataIndex: 0,
         pageShowData: [],
         formDataList: [],
         imgUrl: '', //图片显示根路径
         showStatus: false,
         actionData: {},
         DialogVisible: false,
         seId: "",
         sField: "",
         parentSearchData: {},
         seWidth: 0,
         seTitle: "",
         dialogExcel: false,

      };
   },
   //监听属性 类似于data概念
   computed: {},
   //方法集合
   methods: {
      closeExcel(refresh) {
         this.dialogExcel = false
         if (refresh) this.getDataList()
      },
      sortChange(column) {
         this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
      },
      getSeWidth(e) {
         // console.log(e);
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         // console.log(e);
         this.seTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.DialogVisible = true
         this.seId = sId
         this.sField = sField
         this.parentSearchData[type] = this.getRequestData[type]
      },
      //检索带回数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.getRequestData[item] = val[item]
         })
      },
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1;
            this.getRequestData.end = time;
         }
      },

      //弹窗关闭
      drawerCancel() {
         this.showStatus = false
         this.getDataList()
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页    
            var isPenetrate = true
            // 设置缓存 存入点击单号
            this.resetSetItem('penetrateOrderId', orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage({ //向窗口发送MessageEvent消息
               cmd: 'returnFormJson',
               params: {
                  isPenetrate
               } //参数
            }, '*');
         }
      },
      //图片地址转换
      pictureShow(data) {
         var imgList = [];
         data.forEach((item) => {
            imgList.push(this.imgUrl + '/' + item.fileUrl);
         });
         return imgList;
      },
      isShowData(name, value) {
         switch (name) {
            case "bgmId":
               var dataInfo = sessionStorage.getItem("selectBusinessGoodsEntryInfo");
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo);
                  this.getRequestData.bgmId = dataInfo.bgmId;
                  this.getRequestData.bgmName = dataInfo.bgmName;
               }
               break;

            default:
               this.getRequestData[name] = value;
         }
      },
      getPageInfo() {
         var ss = parent.getMenuInfo(this.$route.path);
         this.getDataTest(ss.jurId);
      },

      // 获取数据列表
      async getDataTest(ids) {
         let responseData = await this.$http.getJur({
            ids: [ids]
         });
         if (responseData.status == 200) {
            this.getButtonList()
            this.pageShowData = responseData.result;
            this.formDataList = this.pageShowData.jurFormVoList
            var obj = {}
            if (this.pageShowData.jurHead) {
               obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
            } else {
               obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            }
            for (const key in obj) {
               this.$set(this.getRequestData, key, obj[key])
            }
            this.$nextTick(async () => {
               //商品分类
               var arr1 = []
               this.pageShowData.jurFormVoList.forEach(item => {
                  var arr
                  if (item.jciId == 11145 || item.jciId == 1077687) {
                     arr = item.jurconfigform.filter(val => val.entityField == 'bgiType')
                     if (arr.length > 0) {
                        if (arr[0].formatterContent != null) {
                           arr1.push(...JSON.parse(arr[0].formatterContent))
                        }
                     }
                  }
               })
               arr1.forEach(item => {
                  this.$set(item, 'label', item.key)
               })
               this.getDataList();
            })
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      clear(val) {
         if (val) {
            var arr = val.split(",")
            arr.forEach(item => {
               this.$set(this.getRequestData, item, "")
            })
         }
      },
      // 动作集合
      actionSet(actionData) {
         switch (actionData.actionType) {
            case 0: //商品
               this.actionData = {
                  cate: 0,
                  formData: this.formDataList,
                  oldData: '',
                  orderId: '',
                  printSouce: '',
                  printJurId: '',
                  fatherType: true
               }
               this.showStatus = true
               break;
            case 1:
               var dataInfo = this.returnData.list[this.selectedDataIndex];
               if (!dataInfo) {
                  this.$message({
                     message: "请先选中要操作的数据",
                     type: "error",
                  });
                  return false;
               }
               this.actionData = {
                  cate: 1,
                  formData: this.formDataList,
                  oldData: dataInfo,
                  orderId: dataInfo.id,
                  printSouce: '',
                  printJurId: '',
                  fatherType: true
               }
               this.showStatus = true
               break;
            case 2:
               this.delDataAction();
               break;
            case 3:
               this.dialogExcel = true
               break;
            case 4://下载模版
               this.hospitalcodeExport();
               break;
         }
      },
      hospitalcodeExport() {
         window.location.href = this.requesUrl + `/hospitalcode/export`;
      },
      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path)
         this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1;
         this.getDataList();
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val;
         this.getDataList();
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1;
         this.getRequestData.rows = val;
         this.getDataList();
      },
      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.hospitalcodeQuery(this.getRequestData);
         if (responseData.status == 200) {
            this.returnData.list = this.$common.getIndex(responseData.result.list);
            this.returnData.pages = responseData.result.pages;
            this.returnData.total = responseData.result.total;
            this.returnData.pageNum = responseData.result.pageNum;
            this.selectedDataIndex = 0;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 删除数据
      delDataAction() {
         var dataInfo = this.returnData.list[this.selectedDataIndex];
         if (!dataInfo) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }
         this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(async () => {
               var delData = {
                  ids: [dataInfo.id],
               };
               let responseData = await this.$http.hospitalcodeDelete(delData);
               if (responseData.status == 200) {
                  this.$message({
                     type: "success",
                     message: "删除成功!",
                  });

                  this.getDataList();
               } else {
                  this.$message({
                     message: responseData.message,
                     type: "error",
                  });
               }
            })
            .catch(() => {
               this.$message({
                  type: "info",
                  message: "已取消删除",
               });
            })
            .catch(() => { });
      },

      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
         
      },
//获取状态
      getIsGsp(str, val) {
         try {
            str && str.replace(/\\/g, "");
            let arr = JSON.parse(str);
            let len = arr.length;
            let newStr = "";
            for (let i = 0; i < len; i++) {
               if (arr[i].key == val) {
                  newStr = arr[i].value;
                  break;
               }
            }
            return newStr;
         } catch (ex) {
            return str;
         }
      },
      //结束时间改成最后时间
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1
            this.getRequestData.end = time
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPageInfo();
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
      this.imgUrl = this.$store.getters.getConfig.imgUrl;
      this.ormId = sessionStorage.getItem('ormId')

   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}

.page_content_center {
   position: relative;
   width: 100%;
   display: flex;
}

#left {
   width: 320px;
   flex-shrink: 0;
   border: 1px solid #eee;
   border-top: none;
}

.li_left {
   height: 30px;
   border-bottom: 1px solid #eee;
}

>>>.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
   background-color: #409eff;
}

>>>.is-current {
   color: #fff;
}

>>>.el-radio-button__inner {
   /* padding: 2px 8px !important; */
   font-size: 12px !important;
}

>>>#left .el-form-item__content,
.el-form-item__label {
   line-height: 15px !important;
}

.close {
   display: inline-block;
   cursor: pointer;
   font-size: 18px;
}

.close:hover {
   color: #409eff;
}
</style>